import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=ae0e173e&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0e173e')) {
      api.createRecord('ae0e173e', component.options)
    } else {
      api.reload('ae0e173e', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=ae0e173e&", function () {
      api.rerender('ae0e173e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Vybq72QuJ8Ln/JS/comp/starrating.vue"
export default component.exports